'use strict';
(function () {
  angular.module('pentaApp').factory('notification.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/notification', {}, {
      remove: {
        method: 'PUT',
        isArray: false
      }
    });
  }

})();